// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "@popperjs/core"
import "bootstrap"
import "@oddcamp/cocoon-vanilla-js"
import { marked } from "marked"
window.marked = marked
import "./get_active_tab_from_url"
import "./save_close_alert"
import "./creator_popover"
import tom_select from "tom-select"
window.TomSelect = tom_select
// import cytoscape from "cytoscape"
// import * as d3 from "d3"
